import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star, Medal } from 'lucide-react';

const StatsBanner = ({ userPoints, userRank, topPoints }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative overflow-hidden rounded-3xl bg-gray-900/80 backdrop-blur-xl border border-gray-700/50 p-6 md:p-8 shadow-[0_0_40px_rgba(139,92,246,0.15)] mb-8"
    >
      {/* Background glow effects */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[50%] -left-[10%] w-64 h-64 bg-purple-600/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-[50%] -right-[10%] w-64 h-64 bg-blue-600/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center gap-6 md:gap-8">
        <div className="flex items-center gap-6">
          <div className="relative">
            <div className="absolute inset-0 bg-yellow-500/20 blur-xl rounded-full animate-pulse"></div>
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-600 p-[2px]">
              <div className="w-full h-full rounded-2xl bg-gray-900 flex items-center justify-center">
                <Trophy className="w-10 h-10 text-yellow-400" />
              </div>
            </div>
          </div>
          
          <div>
            <p className="text-gray-400 text-lg md:text-xl uppercase tracking-wider font-semibold mb-1">Your Performance</p>
            <h2 className="text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              {userPoints || 0} <span className="text-3xl text-purple-400">PTS</span>
            </h2>
          </div>
        </div>

        <div className="flex flex-row gap-4 w-full mt-2">
          <div className="flex-1 flex flex-col items-center bg-gray-800/50 rounded-2xl p-4 md:p-6 border border-gray-700/50 min-w-[9rem] sm:min-w-[10rem]">
            <div className="flex items-center justify-center gap-2 text-gray-400 mb-2">
              <Medal className="w-5 h-5 md:w-6 md:h-6 text-blue-400 shrink-0" />
              <span className="text-sm md:text-base uppercase font-bold tracking-wider whitespace-nowrap">Rank</span>
            </div>
            <p className="text-3xl md:text-4xl font-bold text-white text-center">#{userRank || '--'}</p>
          </div>
          
          <div className="flex-1 flex flex-col items-center bg-gray-800/50 rounded-2xl p-4 md:p-6 border border-gray-700/50 min-w-[9rem] sm:min-w-[10rem]">
            <div className="flex items-center justify-center gap-2 text-gray-400 mb-2">
              <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 shrink-0" />
              <span className="text-sm md:text-base uppercase font-bold tracking-wider whitespace-nowrap">Top Score</span>
            </div>
            <p className="text-3xl md:text-4xl font-bold text-white text-center">{topPoints || 0}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default StatsBanner;
